import _ from 'lodash'
import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  PROJECT_INFORMATION_LIST_REQUEST,
  PROJECT_INFORMATION_LIST_SUCCESS,
  PROJECT_INFORMATION_LIST_FAILURE,
  PROJECT_INFORMATION_LIST_RESET,
  PROJECT_INFORMATION_GET_REQUEST,
  PROJECT_INFORMATION_GET_SUCCESS,
  PROJECT_INFORMATION_GET_FAILURE,
  PROJECT_INFORMATION_GET_RESET,
  PROJECT_INFORMATION_CREATE_REQUEST,
  PROJECT_INFORMATION_CREATE_SUCCESS,
  PROJECT_INFORMATION_CREATE_FAILURE,
  PROJECT_INFORMATION_CREATE_RESET,
  PROJECT_INFORMATION_EDIT_REQUEST,
  PROJECT_INFORMATION_EDIT_SUCCESS,
  PROJECT_INFORMATION_EDIT_FAILURE,
  PROJECT_INFORMATION_EDIT_RESET,
  PROJECT_INFORMATION_AUTO_ADD_REQUEST,
  PROJECT_INFORMATION_AUTO_ADD_SUCCESS,
  PROJECT_INFORMATION_AUTO_ADD_FAILURE,
  PROJECT_INFORMATION_AUTO_ADD_RESET,
  PROJECT_INFORMATION_AUTO_FILL_REQUEST,
  PROJECT_INFORMATION_AUTO_FILL_SUCCESS,
  PROJECT_INFORMATION_AUTO_FILL_FAILURE,
  PROJECT_INFORMATION_AUTO_FILL_RESET,
  PROJECT_INFORMATION_CHANGE_STATUS_REQUEST,
  PROJECT_INFORMATION_CHANGE_STATUS_SUCCESS,
  PROJECT_INFORMATION_CHANGE_STATUS_FAILURE,
  PROJECT_INFORMATION_CHANGE_STATUS_RESET,
  PROJECT_INFORMATION_SUBMIT_REQUEST,
  PROJECT_INFORMATION_SUBMIT_SUCCESS,
  PROJECT_INFORMATION_SUBMIT_FAILURE,
  PROJECT_INFORMATION_SUBMIT_RESET,
  PROJECT_INFORMATION_APPROVE_REQUEST,
  PROJECT_INFORMATION_APPROVE_SUCCESS,
  PROJECT_INFORMATION_APPROVE_FAILURE,
  PROJECT_INFORMATION_APPROVE_RESET,
  PROJECT_INFORMATION_EXPORT_REQUEST,
  PROJECT_INFORMATION_EXPORT_SUCCESS,
  PROJECT_INFORMATION_EXPORT_FAILURE,
  PROJECT_INFORMATION_EXPORT_RESET,
  SHOW_MANUAL_PROJECT_INFORMATION,
  CLOSE_MANUAL_PROJECT_INFORMATION,
  SET_TYPE_MANUAL_PROJECT_INFORMATION,
  PROJECT_INFORMATION_SAVE_SNAPSHOT_REQUEST,
  PROJECT_INFORMATION_SAVE_SNAPSHOT_SUCCESS,
  PROJECT_INFORMATION_SAVE_SNAPSHOT_FAILURE,
  PROJECT_INFORMATION_SAVE_SNAPSHOT_RESET,
  PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST,
  PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS,
  PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE,
  PROJECT_INFORMATION_GET_SNAPSHOT_RESET,
  PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST,
  PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS,
  PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE,
  PROJECT_INFORMATION_CHECK_SUBMIT_RESET,
  REVENUE_PLANNING_SET_TABLE,
  REVENUE_PLANNING_EDIT_TABLE,
  REVENUE_PLANNING_SET_COMPLETE,
  PROJECT_INFORMATION_OPEN_RESPONSE_MODAL,
} from './../../constants'

export function createProjectInformation(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects`,
      method: 'POST',
      types: [
        PROJECT_INFORMATION_CREATE_REQUEST,
        PROJECT_INFORMATION_CREATE_SUCCESS,
        PROJECT_INFORMATION_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getProjectInformation(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects`,
      method: 'GET',
      types: [
        PROJECT_INFORMATION_LIST_REQUEST,
        PROJECT_INFORMATION_LIST_SUCCESS,
        PROJECT_INFORMATION_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getProjectInformationByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}`,
      method: 'GET',
      types: [
        PROJECT_INFORMATION_GET_REQUEST,
        PROJECT_INFORMATION_GET_SUCCESS,
        PROJECT_INFORMATION_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editProjectInformation(id, payload, access_token, commit = true, edit_revenue_allocation = false) {
  _.forIn(payload, (value, key) => {
    if (_.startsWith(key, '$')) {
      delete payload[key]
    }
  })
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}?commit=${commit}&edit_revenue_allocation=${edit_revenue_allocation}`,
      method: 'PUT',
      types: [
        PROJECT_INFORMATION_EDIT_REQUEST,
        PROJECT_INFORMATION_EDIT_SUCCESS,
        PROJECT_INFORMATION_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function changeStatusProjectInformation(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/status`,
      method: 'PUT',
      types: [
        PROJECT_INFORMATION_CHANGE_STATUS_REQUEST,
        PROJECT_INFORMATION_CHANGE_STATUS_SUCCESS,
        PROJECT_INFORMATION_CHANGE_STATUS_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function autoAddResources(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/auto-add-resources`,
      method: 'PUT',
      types: [
        PROJECT_INFORMATION_AUTO_ADD_REQUEST,
        PROJECT_INFORMATION_AUTO_ADD_SUCCESS,
        PROJECT_INFORMATION_AUTO_ADD_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function autoFillManDays(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/auto-fill-man-days`,
      method: 'PUT',
      types: [
        PROJECT_INFORMATION_AUTO_FILL_REQUEST,
        PROJECT_INFORMATION_AUTO_FILL_SUCCESS,
        PROJECT_INFORMATION_AUTO_FILL_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function submitProjectInformation(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/submit`,
      method: 'POST',
      types: [
        PROJECT_INFORMATION_SUBMIT_REQUEST,
        PROJECT_INFORMATION_SUBMIT_SUCCESS,
        PROJECT_INFORMATION_SUBMIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function checkSubmitProjectInformation(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/submit`,
      method: 'POST',
      types: [
        PROJECT_INFORMATION_CHECK_SUBMIT_REQUEST,
        PROJECT_INFORMATION_CHECK_SUBMIT_SUCCESS,
        PROJECT_INFORMATION_CHECK_SUBMIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function approveProjectInformation(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${id}/approve`,
      method: 'POST',
      types: [
        PROJECT_INFORMATION_APPROVE_REQUEST,
        PROJECT_INFORMATION_APPROVE_SUCCESS,
        PROJECT_INFORMATION_APPROVE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function exportProjectInformation(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/export`,
      method: 'GET',
      types: [
        PROJECT_INFORMATION_EXPORT_REQUEST,
        PROJECT_INFORMATION_EXPORT_SUCCESS,
        PROJECT_INFORMATION_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function saveSnapshot(projectID, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${projectID}/snapshot`,
      method: 'POST',
      types: [
        PROJECT_INFORMATION_SAVE_SNAPSHOT_REQUEST,
        PROJECT_INFORMATION_SAVE_SNAPSHOT_SUCCESS,
        PROJECT_INFORMATION_SAVE_SNAPSHOT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getSnapshot(projectID, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/projects/${projectID}/snapshot`,
      method: 'GET',
      types: [
        PROJECT_INFORMATION_GET_SNAPSHOT_REQUEST,
        PROJECT_INFORMATION_GET_SNAPSHOT_SUCCESS,
        PROJECT_INFORMATION_GET_SNAPSHOT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function setRevenuePlanningTable(payload) {
  return {
    type: REVENUE_PLANNING_SET_TABLE,
    payload,
  }
}

export function editRevenuePlanningTable(payload) {
  return {
    type: REVENUE_PLANNING_EDIT_TABLE,
    payload,
  }
}

export function setIncompletedRevenue(payload) {
  return {
    type: REVENUE_PLANNING_SET_COMPLETE,
    payload,
  }
}

export function openResponseModal(payload) {
  return {
    type: PROJECT_INFORMATION_OPEN_RESPONSE_MODAL,
    payload,
  }
}

export function resetGetProjectInformation() {
  return {
    type: PROJECT_INFORMATION_LIST_RESET,
  }
}
export function resetGetProjectInformationByID() {
  return {
    type: PROJECT_INFORMATION_GET_RESET,
  }
}
export function resetCreateProjectInformation() {
  return {
    type: PROJECT_INFORMATION_CREATE_RESET,
  }
}
export function resetEditProjectInformation() {
  return {
    type: PROJECT_INFORMATION_EDIT_RESET,
  }
}
export function resetAutoAddResources() {
  return {
    type: PROJECT_INFORMATION_AUTO_ADD_RESET,
  }
}
export function resetAutoFillManDays() {
  return {
    type: PROJECT_INFORMATION_AUTO_FILL_RESET,
  }
}
export function resetChangeStatusProjectInformation() {
  return {
    type: PROJECT_INFORMATION_CHANGE_STATUS_RESET,
  }
}
export function resetCheckSubmitProjectInformation() {
  return {
    type: PROJECT_INFORMATION_CHECK_SUBMIT_RESET,
  }
}
export function resetSubmitProjectInformation() {
  return {
    type: PROJECT_INFORMATION_SUBMIT_RESET,
  }
}
export function resetApproveProjectInformation() {
  return {
    type: PROJECT_INFORMATION_APPROVE_RESET,
  }
}
export function openManual() {
  return {
    type: SHOW_MANUAL_PROJECT_INFORMATION,
  }
}
export function closeManual() {
  return {
    type: CLOSE_MANUAL_PROJECT_INFORMATION,
  }
}
export function setTypeManual(payload) {
  return {
    type: SET_TYPE_MANUAL_PROJECT_INFORMATION,
    payload,
  }
}
export function resetExportProjectInformation() {
  return {
    type: PROJECT_INFORMATION_EXPORT_RESET,
  }
}
export function resetSaveSnapshot() {
  return {
    type: PROJECT_INFORMATION_SAVE_SNAPSHOT_RESET,
  }
}
export function resetGetSnapshot() {
  return {
    type: PROJECT_INFORMATION_GET_SNAPSHOT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/project-information/project-information-action.js